import { Navigate, replace, Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "../pages/dashboard/Dashboard";
import { useEffect } from "react";

export const PrivateRoutes = () => {

  const navigate = useNavigate()

  useEffect(() => {
    navigate("/", {replace : true})
  },[])

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      {/* <Route path="/PowerBIReport" element={<PowerBIReport />} />
      <Route path="/db" element={<DB />} /> */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

